import axios from "axios";
import { withSkipGlobalError } from "@/lib/http/skip-global-error";
import { editorHeaders } from "@/lib/sacred-library/sacred-library-api";
import { getApiBaseUrl } from "@/lib/api-base";

const API = getApiBaseUrl();

function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

export async function fetchSacredProfile(token) {
  const res = await axios.get(`${API}/user/profile`, withSkipGlobalError({ headers: authHeaders(token) }));
  return res.data;
}

export async function saveSacredProfile(token, body) {
  const res = await axios.post(`${API}/user/profile`, body, withSkipGlobalError({ headers: authHeaders(token) }));
  return res.data;
}

export async function fetchAlertsToday(token) {
  const res = await axios.get(`${API}/alerts/today`, withSkipGlobalError({ headers: authHeaders(token) }));
  return res.data;
}

export async function sendTestNotification(token, channels) {
  const res = await axios.post(
    `${API}/user/notifications/test`,
    { channels },
    withSkipGlobalError({ headers: authHeaders(token) })
  );
  return res.data;
}

export async function fetchInAppNotifications(token) {
  const res = await axios.get(`${API}/user/notifications/inapp`, withSkipGlobalError({ headers: authHeaders(token) }));
  return res.data;
}

export async function fetchAdminNotificationLogs() {
  const res = await axios.get(`${API}/admin/notifications/logs`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data?.logs ?? [];
}

export async function fetchAdminNotificationSchedules() {
  const res = await axios.get(`${API}/admin/notifications/schedules`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data;
}

export async function triggerAdminNotificationRun() {
  const res = await axios.post(`${API}/admin/notifications/run`, {}, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data;
}

export async function fetchAdminNotificationConfig() {
  const res = await axios.get(`${API}/admin/notifications/config`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data?.config;
}

export async function saveAdminNotificationConfig(body) {
  const res = await axios.put(
    `${API}/admin/notifications/config`,
    body,
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data?.config;
}

export async function fetchAlertsDebug(email) {
  const q = email ? `?email=${encodeURIComponent(email)}` : "";
  const res = await axios.get(`${API}/alerts/debug${q}`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data;
}

export async function fetchSacredProfileByEmail(email) {
  const debug = await fetchAlertsDebug(email);
  return debug.users?.[0] ?? null;
}

export async function triggerAdminTestAlert(email) {
  const res = await axios.post(
    `${API}/admin/alerts/test-user`,
    { email },
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}
